import { LoadScript } from "@react-google-maps/api";
import {
  AutoComplete,
  Breadcrumb,
  Col,
  Form,
  Input,
  Row,
  Select,
  Switch,
  Spin,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getRequest, patchRequest, postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import EmailField from "../../common/htmlComponents/EmailField";
import InputField from "../../common/htmlComponents/InputField";
import "../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
// import CompanyDepoAddress from "./CompanyDepoAddress";

const { Option } = Select;
const AcceptCompanyKeyAdd = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const libraries = ["places"];
  // const formRef = useRef();
  const { TextArea } = Input;
  const formRef = useRef();
  const [form] = Form.useForm();
  // const { isLoaded, loadError } = useLoadScript({
  //   googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  //   libraries: ['places'],
  // });
  const { id } = useParams();
  const CompanyAPIId = id ? atob(id) : null;
  const [options, setOptions] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  // const { Panel } = Collapse;
  // const [sizepolicecheck, setSizepolicecheck] = useState(null);
  // const [sizeuploaddrivinglicense, setsizeuploaddrivinglicense] =
  //   useState(null);
  const [fileLink, setFileLink] = useState(null);
  const [fileLinkpolice_check, setFileLinkpolice_check] = useState(null);
  // const [fileName, setFileName] = useState(null);
  // const [fileNamepolice_check, setFileNamepolice_check] = useState(null);
  // const [uploadFile, setUploadFile] = useState("");
  // const [uploadFilepolicecheck, setUploadFilepolicecheck] = useState("");

  const initialState = {
    company: null,
    company_api_key: null,
    client_name: null,
    company_secret_key: null,
    company_webhook_url: null,
    company_documentation_link: null,
    additional_note: null,
  };
  const [state, setState] = useState(initialState);
  const [btnLoading, setBtnLoading] = useState(false);
  const [apiLoading, setapiloading] = useState(false);
  // const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [reload, setReload] = useState(false);
  // const handleCheckboxChange = (e) => {
  //   setChecked(e.target.checked);
  //   setState((prevState) => ({
  //     ...prevState,
  //     term_condition_accept: e.target.checked,
  //   }));
  // };

  const urls = state?.driving_license;
  // const urlone = state.document_url;

  let filenamelicense = "";
  // let filenameadhar = "";
  try {
    if (fileLink) {
      filenamelicense = urls.split("/").pop();
    }
  } catch (e) {
    filenamelicense = "";
  }

  const url = state?.police_check;

  let filenamepolice_check = "";
  try {
    if (fileLinkpolice_check) {
      filenamepolice_check = url.split("/").pop();
    }
  } catch (e) {
    filenamepolice_check = "";
  }
  const setWeightSizeFieldValue = (data) => {
    const fieldObject = {};
    data.forEach((address, index) => {
      fieldObject[`depo_street_address${index}`] = address.depo_street_address;
      fieldObject[`depo_suburb${index}`] = address.depo_suburb;
      fieldObject[`state${index}`] = address.state;
      fieldObject[`postcode${index}`] = address.postcode;
      fieldObject[`additional_details${index}`] = String(
        address.additional_details
      );
    });

    formRef.current.setFieldsValue(fieldObject); // Set form values
  };

  useEffect(() => {
    const companyGetById = async () => {
      setapiloading(true);
      try {
        const apiResponse = await getRequest(
          `api-integration/${CompanyAPIId}/`
        );
        console.log("apiResponse Integration", apiResponse);
        if (apiResponse?.data?.success) {
          const companyData = apiResponse.data.data;
          // Set state with initial values

          setState({
            ...apiResponse?.data?.data,
          });

          formRef.current.setFieldsValue({
            ...apiResponse?.data?.data,
          });

          formRef.current.setFieldsValue({
            ...companyData,
          });

          setapiloading(false);
        }
      } catch (error) {
        setapiloading(false);
      }
    };
    if (CompanyAPIId !== null) {
      companyGetById();
    }
  }, [CompanyAPIId, t, reload]);
  const getCompanyName = async () => {
    try {
      const response = await getRequest("company/?no_pagination=true");
      if (response.data.success) {
        const { data } = response.data;
        setCompanyList(data);
        formRef.current.setFieldsValue(response.data.data);
      }
    } catch (error) {
      ErrorNotificationMsg("Failed to fetch companies");
    }
  };
  useEffect(() => {
    getCompanyName();
    // fetchIntegrations();
  }, []);

  const handleCompanyChange = (value) => {
    setState((prev) => ({
      ...prev,
      company: value,
    }));
  };
  const handleSelect = (value) => {
    const selected = options.find((option) => option.value === value);
    if (selected && selected.place_id) {
      const service = new window.google.maps.places.PlacesService(
        document.createElement("div")
      );
      service.getDetails({ placeId: selected.place_id }, (place, status) => {
        if (
          status === window.google.maps.places.PlacesServiceStatus.OK &&
          place
        ) {
          setState((prevstate) => ({
            ...prevstate,
            address: place.formatted_address,
            suburb:
              place.address_components.find((ac) =>
                ac.types.includes("locality")
              )?.long_name || "",
            state:
              place.address_components.find((ac) =>
                ac.types.includes("administrative_area_level_1")
              )?.short_name || "",
            pincode:
              place.address_components.find((ac) =>
                ac.types.includes("postal_code")
              )?.long_name || "",
            pickuppoint_coordinates: {
              latitude: place.geometry.location.lat(),
              longitude: place.geometry.location.lng(),
            },
          }));
          form.setFieldsValue({
            address: place.formatted_address,
            suburb:
              place.address_components.find((ac) =>
                ac.types.includes("locality")
              )?.long_name || "",
            state:
              place.address_components.find((ac) =>
                ac.types.includes("administrative_area_level_1")
              )?.short_name || "",
            pincode:
              place.address_components.find((ac) =>
                ac.types.includes("postal_code")
              )?.long_name || "",
          });
        }
      });
    }
  };

  const handleSearch = useCallback(
    debounce((value) => {
      // setLoading(true);

      const service = new window.google.maps.places.AutocompleteService();

      if (value !== "") {
        service.getPlacePredictions({ input: value }, (predictions, status) => {
          if (
            status === window.google.maps.places.PlacesServiceStatus.OK &&
            predictions
          ) {
            setOptions(
              predictions.map((prediction) => ({
                value: prediction.description,
                place_id: prediction.place_id,
              }))
            );
            setLoading(false);
          } else {
            setOptions([]);
            setLoading(false);
          }
        });
      } else {
        setOptions([]);
        setLoading(false);
        setState((prevstate) => ({
          ...prevstate,
          address: "",
          suburb: "",
          state: "",
          pincode: "",
          pickuppoint_coordinates: {
            latitude: null,
            longitude: null,
          },
        }));
        form.setFieldsValue({
          address: "",
          suburb: "",
          state: "",
          pincode: "",
        });
      }
    }, 300),
    []
  );

  const handleInputChange = (name, value) => {
    // let { name, value } = e.target;
    setState({ ...state, [name]: value });
  };
  const handleInputChangeEmail = (e) => {
    let { name, value } = e.target;
    // setState({ ...state, [name]: value });
    setState({ ...state, [name]: value.toLowerCase() });
  };
  const handleKeyPress = (e) => {
    // Allow only lowercase letters, numbers, and specific symbols
    const allowedChars = /^[a-z0-9@._-]*$/; // Add other allowed characters as needed
    if (!allowedChars.test(e.key) && e.key !== "Backspace") {
      e.preventDefault();
    }
  };

  const phoneValidLength = state.number;

  const validatePhoneNumber = () => {
    if (
      (phoneValidLength && phoneValidLength.length < 8) ||
      phoneValidLength === null ||
      phoneValidLength === ""
    ) {
      return Promise.reject(new Error("Please enter valid phone."));
    }

    return Promise.resolve();
  };

  const handleSubmit = async () => {
    const payload = {
      company: state?.company,
      company_api_key: state?.company_api_key,
      client_name: state?.client_name,
      company_secret_key: state?.company_secret_key,
      company_webhook_url: state?.company_webhook_url,
      company_documentation_link: state?.company_documentation_link,
      additional_note: state?.additional_note,
    };
    try {
      setBtnLoading(true);
      let response;

      if (CompanyAPIId === null) {
        response = await postRequest("api-integration/", payload);
      } else {
        response = await patchRequest(
          `api-integration/${CompanyAPIId}/`,
          payload
        );
      }
      if (response.data.success) {
        SuccessNotificationMsg(
          CompanyAPIId === null
            ? t("Company Integration Key Added Sucessfully")
            : t("Company Integration Key Updated Sucessfully")
        );
        // setState(initialState);
        // formRef.current.setFieldsValue(initialState);
        setBtnLoading(false);
        setReload(!reload);

        navigate("/accept-company-key");
      }
    } catch (error) {
      // if (CompanyAPIId === null) {
      //   ErrorNotificationMsg(
      //     t("error_in_adding_company")
      //   );
      // }
      // if (CompanyAPIId !== null && !error?.message) {
      //   ErrorNotificationMsg(
      //     t("error_in_updating_company")
      //   );
      // }
      setBtnLoading(false);
    }
  };

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            {CompanyAPIId ? (
              <h3>Edit Integration</h3>
            ) : (
              <h3>Add New Integration</h3>
            )}

            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                <Link to="/accept-company-key">
                  {" "}
                  {t("Company API Integration")}
                </Link>
              </Breadcrumb.Item>

              <Breadcrumb.Item>
                {CompanyAPIId ? "Edit Integration" : "Add New Integration"}
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>

      <section className="grid-sec FormSection Container">
        <div className="FormBody">
          <Form
            ref={formRef}
            form={form}
            onFinish={handleSubmit}
            layout="vertical"
          >
            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="company"
                  label={t("Company")}
                  rules={[
                    {
                      required: true,
                      message: "Please select company",
                    },
                  ]}
                >
                  <Select
                    className="ant-input parcel-input"
                    placeholder={t("Select company")}
                    showArrow
                    showSearch
                    name="company"
                    optionFilterProp="children"
                    onChange={(value) => handleCompanyChange(value)}
                  >
                    {companyList?.map((item) => (
                      <Option key={item.id} value={item.id}>
                        {item.company_name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="client_name"
                  label={t("Client Name")}
                  rules={[
                    {
                      required: true,
                      message: "Please enter client name",
                    },
                  ]}
                >
                  <Input
                    // className="ant-input parcel-input"
                    placeholder={t("Enter Client Name")}
                    value={state.client_name}
                    onChange={(e) =>
                      handleInputChange("client_name", e.target.value)
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="company_secret_key"
                  label={t("Secret Key")}
                  rules={[
                    {
                      required: true,
                      message: "Please enter secret key",
                    },
                  ]}
                >
                  <Input.Password
                    // className="ant-input parcel-input"
                    placeholder={t("Enter Secret key")}
                    value={state.company_secret_key}
                    onChange={(e) =>
                      handleInputChange("company_secret_key", e.target.value)
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="company_api_key"
                  label={t("API Key")}
                  rules={[
                    {
                      required: true,
                      message: "Please enter API key",
                    },
                  ]}
                >
                  <Input.Password
                    // className="ant-input parcel-input"
                    placeholder={t("Enter API key")}
                    value={state.company_api_key}
                    onChange={(e) =>
                      handleInputChange("company_api_key", e.target.value)
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12}>
                <Form.Item
                  name="company_webhook_url"
                  label={t("Webhook URL")}
                  rules={[
                    {
                      required: true,
                      message: "Please enter webhook URL",
                    },
                    {
                      type: "url",
                      message: "Please enter a valid URL",
                    },
                  ]}
                >
                  <Input
                    className="ant-input parcel-input"
                    placeholder={t("Enter webhook URL")}
                    value={state.company_webhook_url}
                    onChange={(e) =>
                      handleInputChange("company_webhook_url", e.target.value)
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12}>
                <Form.Item
                  name="company_documentation_link"
                  label={t("Documentation Link")}
                  rules={[
                    {
                      required: true,
                      message: "Please enter documentation link",
                    },
                    {
                      type: "link",
                      message: "Please enter a valid link",
                    },
                  ]}
                >
                  <Input
                    className="ant-input parcel-input"
                    placeholder={t("Enter  Documentation Link")}
                    value={state.company_documentation_link}
                    onChange={(e) =>
                      handleInputChange(
                        "company_documentation_link",
                        e.target.value
                      )
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={16}>
              <Col span={24}>
                <Form.Item
                  name="additional_note"
                  label={t("Additional Configuration")}
                >
                  <TextArea
                    rows={4}
                    placeholder={t(
                      "Enter any additional configuration in JSON format"
                    )}
                    value={state.additional_note}
                    onChange={(e) =>
                      handleInputChange("additional_note", e.target.value)
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            {/* <Row>
              <Col span={24}>
                <Form.Item
                  name="is_active"
                  label={t("Status")}
                  valuePropName="checked"
                >
                  <Switch
                    checked={state?.is_active}
                    onChange={(checked) =>
                      handleInputChange("is_active", checked)
                    }
                  />
                </Form.Item>
              </Col>
            </Row> */}

            <Row>
              <Col span={24}>
                <ButtonField
                  className="ant-btn ant-btn-primary save-gradient-btn SaveGradiantBtn"
                  type="primary"
                  htmlType="submit"
                  label="Submit"
                  loading={loading}
                />
              </Col>
            </Row>
          </Form>
        </div>
      </section>
    </>
  );
};

export default AcceptCompanyKeyAdd;
